<script>
    import {flip} from 'svelte/animate';
    import R, {LOADER} from "../lib/requests";
    import Alert from "../stores/alerts";
    import Notifier from "../stores/notifier";
    import WsServiceField from "./WsServiceField.svelte";
    import Icon from "../components/Icon.svelte";

    export let serviceId = null;
    export let fields = null;

    let hovering = false;

    const dragstart = (event, i) => {
        event.dataTransfer.effectAllowed = 'move';
        event.dataTransfer.dropEffect = 'move';
        event.dataTransfer.setData('text/plain', i);
    }

    const drop = (event, target) => {
        event.dataTransfer.dropEffect = 'move';
        const start = parseInt(event.dataTransfer.getData("text/plain"));
        const newTracklist = fields;

        if (start < target) {
            newTracklist.splice(target + 1, 0, newTracklist[start]);
            newTracklist.splice(start, 1);
        } else {
            newTracklist.splice(target, 0, newTracklist[start]);
            newTracklist.splice(start + 1, 1);
        }
        fields = newTracklist;
        hovering = null;
        saveOrder();
    }

    const onAddField = () => {
        // remove new unsaved field
        fields = fields.filter(x => x.id !== 0);

        let field = {
            id: 0,
            service_id: serviceId,
            name: '',
            field_type_id: 0,
            on_edit: true,
        };

        fields = [...fields, field];
    }

    const saveOrder = () => {
        const onSuccess = result => {
        }

        const onFailure = err => {
        };

        let data = {
            service_id: serviceId,
            fields: []
        }
        fields.map(item => {
            data.fields.push(item.id);
        });
        R.handle(R.ws_service.fieldOrder, data, onSuccess, onFailure, LOADER.NONE);
    }

    const deleteField = ({detail: field}) => {
        if (field.id === 0) {
            fields = fields.filter(x => x.id !== 0);
            return;
        }

        const onSuccess = result => {
            fields = fields.filter(x => x.id !== field.id);
            Notifier.showMessage("Το πεδίο διαγράφτηκε");
        }

        const onFailure = err => {
            Alert.warning("Πεδίο Υπηρεσίας", err.message);
        };

        R.handle(R.ws_service.fieldDelete, field.id, onSuccess, onFailure, LOADER.POPUP);
    }
</script>

<button class="btn btn-link ps-0 pe-0" on:click="{ onAddField }">
    <Icon name="plus-circle" size="16" strokeWidth="2"/>
    προσθήκη πεδίου
</button>

{#if fields && fields.length}
    <div class="mt-2">
        {#each fields as field, index (field.id)}
            <div class="list-item" animate:flip="{{ duration: 100 }}"
                 draggable={true}
                 on:dragstart={event => dragstart(event, index)}
                 on:drop|preventDefault={event => drop(event, index)}
                 ondragover="return false"
                 on:dragenter={() => hovering = index}
                 class:is-active={hovering === index}>
                <WsServiceField bind:field={ field }
                                    on:delete="{ deleteField }"
                />
            </div>
        {/each}
    </div>
{/if}

<style>
    .list-item {
        display: block;
        background: #fff;
    }

    .list-item.is-active {
        background-color: #e4eaee;
    }
</style>